export class EmailTemplate {
    EmailTemplateId:number;
    TemplateName:string; 
    Subject:string;
    Body:string;
    TemplateCode:string;
}
